<template>
    <div>
        <div class="row">
            <dl class="col-12 col-lg-3">
                <dt>
                    Tipo de Documento
                </dt>
                <dd>
                    {{ form.customer.document_type ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-3">
                <dt>
                    Documento
                </dt>
                <dd>
                    {{ form.customer.document ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-6">
                <dt>
                    Nome / Razão Social
                </dt>
                <dd>
                    {{ form.customer.name ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-3">
                <dt>
                    Telefone
                </dt>
                <dd>
                    {{ form.customer.phones?.mobile_phone?.area_code }}
                    {{ form.customer.phones?.mobile_phone?.number }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-5">
                <dt>
                    Email
                </dt>
                <dd>
                    {{ form.customer.email ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-4">
                <dt>
                    CEP
                </dt>
                <dd>
                    {{ form.customer?.address?.zip_code ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-6">
                <dt>
                    Endereço
                </dt>
                <dd>
                    {{ !!form.customer?.address?.line_1 ? form.customer?.address?.line_1 : '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-3">
                <dt>
                    Estado
                </dt>
                <dd>
                    {{ form.customer?.address?.state ?? '---' }}
                </dd>
            </dl>
            <dl class="col-12 col-lg-3">
                <dt>
                    Cidade
                </dt>
                <dd>
                    {{ form.customer?.address?.city ?? '---' }}
                </dd>
            </dl>
        </div>

        <resume-subscription :resume="resume" />
    </div>
</template>
<script>
import ResumeSubscription from "../components/ResumeSubscription.vue";
import price from "../subscription/mixins/price";

export default {
    components: {ResumeSubscription},
    mixins: [price],
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    computed: {
        resume() {
            return this.calculeResume(this.form.plans)
        }
    },
}
</script>

<style scoped>

</style>
